import React, { useEffect, useState, useLayoutEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { openLink } from '../utils';
import { singleStoryStyles } from './style';
import { getSingleStory } from '../services/storyService';
import WaveformSinger from './WaveformSinger';
import ProgressBar from '../components/ProgressBar';
import Video from '../components/SingleStory/Video';
import Slideshow from '../components/SingleStory/Slideshow';
import SingleStoryComponent from '../components/SingleStory';
import Description from '../components/SingleStory/Description';
import RelatedStories from '../components/SingleStory/RelatedStories';

const SingleStory = () => {
	const navigate = useNavigate();
	const { slug } = useParams();
	const classes = singleStoryStyles();
	const [story, setStory] = useState(null);
	const [size, setSize] = useState([0, 0]);
	const [loader, setLoader] = useState(true);
	const [showContent, setShowContent] = useState(false);

	useLayoutEffect(() => {
		setLoader(false);
		function updateSize() {
			setSize([window.innerWidth, window.innerHeight]);
		}

		window.addEventListener('resize', updateSize);
		updateSize();
		return () => window.removeEventListener('resize', updateSize);
	}, []);

	useEffect(() => {
		setLoader(true);
		setShowContent(false);
		// Clearing story synchronously cleans up the showContent timer (the
		// effect below depends on `story`) so an old timer can't fire against
		// the previous story's data mid-navigation.
		setStory(null);
		if (slug) {
			(async function fetchStory() {
				const data = await getSingleStory(slug);
				setStory(data);
				window.scrollTo(0, 0);
				setLoader(false);
			})();
		}
	}, [slug]);

	useEffect(() => {
		if (!story) return undefined;
		const t = setTimeout(() => setShowContent(true), 800);
		return () => clearTimeout(t);
	}, [story]);

	return (
		<>
			<ProgressBar active={!story || loader} />
			{!story || loader ? null : (
				<>
					{story && story.type === 'Podcast' && <WaveformSinger story={story} />}
					{story && story.type === 'Review' && <Slideshow story={story} />}
					{story && story.type !== 'Podcast' && story.type !== 'Review' && (
						<Video classes={classes} story={story} size={size} />
					)}
					<div className={classes.container}>
						{showContent && story && <SingleStoryComponent classes={classes} story={story} />}
						{showContent && story?.related_stories && (
							<RelatedStories navigate={navigate} classes={classes} story={story} />
						)}
						<Description handler={openLink} classes={classes} navigate={navigate} />
					</div>
				</>
			)}
		</>
	);
};

export default SingleStory;
